module.exports = __webpack_public_path__ + "static/media/background.a605fc16.svg";